import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";

import queryString from "querystring";

import { Dropdown, Form, Input, Menu, Row } from "antd";

import Swal from "sweetalert2";

import channelUserApi from "../../apis/ChannelUser.api";
import { setChannelUser, setUser } from "../../redux/store/auth/authDuck";
import { loginAlert, toastAlert } from "../AlertComponent";

const ChannelHeader = () => {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();

	const path = location.pathname;
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const user = useSelector((state) => state.auth.user);
	const [searchValue, setSearchValue] = useState("");

	const wrongPath = (e) => {
		if (!reduxChannel?.user_id) {
			e.preventDefault();
			e.stopPropagation();
			toastAlert("잘못된 접근입니다.");
		}
	};

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	/**
	 * 채널 유저 로그아웃
	 * @param e
	 */
	const userLogout = async (e) => {
		e.preventDefault();
		let { pathname, search } = window.location;
		const backPage = pathname + search;
		const param = {
			id: cUser?.id,
			influencer_id: reduxChannel?.user_id,
		};
		const res = await channelUserApi.logout(param);
		if (res.code === 200) {
			localStorage.removeItem("accessToken");
			localStorage.removeItem("refreshToken");
			localStorage.removeItem("admin:accessToken");
			localStorage.removeItem("admin:refreshToken");
			// if (backPage) {
			//     history.replace(backPage);
			// } else {
			Swal.fire({
				customClass: "alert-custom",
				text: "로그아웃이 되었습니다.",
				confirmButtonText: "확인",
			});
			// history.go(0);
			// history.replace(`/together/channel?id=${reduxChannel?.influencer_id}`)
			// }
			const queryJson = queryString.parse(
				window.location.search?.replace("?", "")
			);
			const userId = queryJson?.userId;
			if (userId) {
				const { pathname, search } = history?.location ?? {};
				const newSearch = search?.split("&userId")[0];
				history.replace(`${pathname + newSearch}`);
			} else {
				window.scrollTo({
					top: 0,
					// behavior: 'smooth'
				});
			}

			dispatch(setChannelUser(null));
			dispatch(setUser(null));
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			});
		}
		// }
	};

	const dropdownMenu = (
		<Menu>
			<Menu.Item>
				<Link
					to={`/together/channel?id=${reduxChannel?.influencer_id}`}
					style={
						path === "/together/channel"
							? {
									color: "#212529",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					홈
				</Link>
			</Menu.Item>
			{reduxChannel?.ingredient_menu_show && (
				<Menu.Item>
					<Link
						to={`/together/channel/ingredients?id=${reduxChannel?.influencer_id}`}
						onClick={wrongPath}
						style={
							// path === "/together/channel/ingredients" ? {
							path.includes("/together/channel/ingredients")
								? {
										color: "#212529",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						성분별
					</Link>
				</Menu.Item>
			)}

			{reduxChannel?.function_menu_show && (
				<Menu.Item>
					<Link
						to={`/together/channel/functions?id=${reduxChannel?.influencer_id}`}
						onClick={wrongPath}
						style={
							path.includes("/together/channel/functions")
								? {
										color: "#212529",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						고민별
					</Link>
				</Menu.Item>
			)}
			{reduxChannel?.combination_menu_show && (
				<Menu.Item>
					<Link
						to={`/together/channel/combinations?id=${reduxChannel?.influencer_id}`}
						onClick={wrongPath}
						style={
							path.includes("/together/channel/combinations")
								? {
										color: "#212529",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						조합별
					</Link>
				</Menu.Item>
			)}
			{reduxChannel?.inquiry_menu_show && (
				<Menu.Item>
					<Link
						to={`/together/channel/inquiry/board?id=${reduxChannel?.influencer_id}`}
						style={
							path.includes("/together/channel/inquiry")
								? {
										color: "#212529",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						상담 게시판
					</Link>
				</Menu.Item>
			)}
			{reduxChannel?.inquiry_link && (
				<Menu.Item>
					<Link
						to={`/together/channel?id=${reduxChannel?.influencer_id}`}
						onClick={(e) => {
							if (reduxChannel?.user_id) {
								window.open(reduxChannel?.inquiry_link);
							} else {
								e.preventDefault();
								e.stopPropagation();
								toastAlert("잘못된 접근입니다.");
							}
						}}
					>
						1:1 무료상담
					</Link>
				</Menu.Item>
			)}
			{/*{reduxChannel?.youtube_link && (*/}
			{/*    <Menu.Item>*/}
			{/*        <Link to={`/together/channel?id=${reduxChannel?.influencer_id}`}*/}
			{/*              onClick={(e) => {*/}
			{/*                  if (reduxChannel?.user_id) {*/}
			{/*                      window.open(reduxChannel?.youtube_link);*/}
			{/*                  } else {*/}
			{/*                      e.preventDefault();*/}
			{/*                      e.stopPropagation();*/}
			{/*                      alert("잘못된 접근입니다.")*/}
			{/*                  }*/}
			{/*              }}>*/}
			{/*            유튜브 보기*/}
			{/*        </Link>*/}
			{/*    </Menu.Item>*/}
			{/*)}*/}

			{/*{reduxChannel?.instagram_link && (*/}
			{/*    <Menu.Item>*/}
			{/*        <Link to={`/together/channel?id=${reduxChannel?.influencer_id}`}*/}
			{/*              onClick={(e) => {*/}
			{/*                  if (reduxChannel?.user_id) {*/}
			{/*                      window.open(reduxChannel?.instagram_link);*/}
			{/*                  } else {*/}
			{/*                      e.preventDefault();*/}
			{/*                      e.stopPropagation();*/}
			{/*                      alert("잘못된 접근입니다.")*/}
			{/*                  }*/}
			{/*              }}>*/}
			{/*            인스타그램 보기*/}
			{/*        </Link>*/}
			{/*    </Menu.Item>*/}
			{/*)}*/}
		</Menu>
	);

	return (
		<Row
			align="middle"
			wrap={false}
			className="together-header-wrap channel-header-wrap noselect header-link-div channel-home-header-wrap"
			style={{ gap: "0.5em", position: "relative" }}
		>
			{path.includes("together/channel") && reduxChannel.user_id === 7 && (
				<div className={`header-link-div`}>
					<Dropdown
						overlay={dropdownMenu}
						placement="bottomLeft"
						arrow={true}
						trigger={["click"]}
						className={`menu-dropdown`}
					>
						<img
							src={`/assets/images/hamburger-icon.png`}
							alt={`햄버그 아이콘`}
							style={{
								width: "1.5em",
								height: "auto",
								cursor: "pointer",
							}}
						/>
					</Dropdown>
				</div>
			)}
			{!!mediaResult &&
				reduxChannel?.user_id !== 7 &&
				(history.location?.pathname?.includes("/community") ||
					history.location?.pathname?.includes("/communities") ||
					history.location?.pathname?.includes("/combination") ||
					history.location?.pathname?.includes("/ingredient") ||
					history.location?.pathname?.includes("/function")) && (
					<img
						src={`/assets/images/go-back.png`}
						alt={`뒤로가기`}
						style={{
							width: "auto",
							height: "1.5em",
							cursor: "pointer",
							marginRight: "0.5em",
						}}
						onClick={() => {
							if (history?.length > 1) {
								history.goBack();
							} else {
								history.push(
									`/together/channel?id=${reduxChannel?.influencer_id}`
								);
							}
						}}
					/>
				)}
			<Link
				to={`/together/channel?id=${reduxChannel?.influencer_id}`}
				className={`channel-header-logo`}
			>
				<img
					src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}.${reduxChannel?.profile_img_type}`}
					// src={`/assets/images/channel/doctor.png`}
					className={`channel-header-img`}
					onError={({ currentTarget }) => {
						currentTarget.onerror = null; // prevents looping
						// currentTarget.style.display = "none";
						currentTarget.src = `/assets/images/channel/basic.png`;
					}}
					alt={`채널 이미지`}
				/>
				<div className={`channel-title-div`}>
					{reduxChannel?.user_id === 9 ? (
						<h1 className={`channel-header-title`}>오징어 하우스</h1>
					) : (
						<h1 className={`channel-header-title`}>
							{reduxChannel?.nickname ?? "채널명"}
						</h1>
					)}
					{reduxChannel?.user_id === 9 ? (
						<p>가장 쉬운 건강 채널</p>
					) : (
						<p>영양제 상담소</p>
					)}
				</div>
			</Link>
			{((path.includes("together/channel") &&
				!path.includes("policy") &&
				!path.includes("term")) ||
				path.includes("@")) && (
				<>
					<div
						className={`link-group`}
						style={reduxChannel?.user_id === 9 ? { display: "none" } : {}}
					>
						<Link
							to={`/together/channel?id=${reduxChannel?.influencer_id}`}
							style={
								path === "/together/channel"
									? {
											color: "#212529",
											fontWeight: "bold",
									  }
									: {}
							}
						>
							홈
						</Link>
						{reduxChannel?.ingredient_menu_show && (
							<Link
								to={`/together/channel/ingredients?id=${reduxChannel?.influencer_id}`}
								onClick={wrongPath}
								style={
									path.includes("/together/channel/ingredients")
										? {
												color: "#212529",
												fontWeight: "bold",
										  }
										: {}
								}
							>
								{reduxChannel?.user_id === 9 ? "고민별" : "성분별"}
							</Link>
						)}
						{reduxChannel?.function_menu_show && (
							<Link
								to={`/together/channel/functions?id=${reduxChannel?.influencer_id}`}
								onClick={wrongPath}
								style={
									path.includes("/together/channel/functions")
										? {
												color: "#212529",
												fontWeight: "bold",
										  }
										: {}
								}
							>
								고민별
							</Link>
						)}
						{reduxChannel?.combination_menu_show && (
							<Link
								to={`/together/channel/combinations?id=${reduxChannel?.influencer_id}`}
								onClick={wrongPath}
								style={
									path.includes("/together/channel/combinations")
										? {
												color: "#212529",
												fontWeight: "bold",
										  }
										: {}
								}
							>
								조합별
							</Link>
						)}
						{/*{reduxChannel?.user_id !== 7 && (*/}
						{reduxChannel?.inquiry_menu_show && (
							<Link
								to={`/together/channel/inquiry/board?id=${reduxChannel?.influencer_id}`}
								style={
									path.includes("/together/channel/inquiry")
										? {
												color: "#212529",
												fontWeight: "bold",
										  }
										: {}
								}
							>
								상담 게시판
							</Link>
						)}
						{reduxChannel?.inquiry_link && (
							<Link
								to={`/together/channel?id=${reduxChannel?.influencer_id}`}
								onClick={(e) => {
									if (reduxChannel?.user_id) {
										window.open(reduxChannel?.inquiry_link);
									} else {
										e.preventDefault();
										e.stopPropagation();
										toastAlert("잘못된 접근입니다.");
									}
								}}
							>
								1:1 무료상담
							</Link>
						)}
						{/*{reduxChannel?.youtube_link && (*/}
						{/*    <Link to={`/together/channel?id=${reduxChannel?.influencer_id}`}*/}
						{/*          onClick={(e) => {*/}
						{/*              if (reduxChannel?.user_id) {*/}
						{/*                  window.open(reduxChannel?.youtube_link)*/}
						{/*              } else {*/}
						{/*                  e.preventDefault();*/}
						{/*                  e.stopPropagation();*/}
						{/*                  alert("잘못된 접근입니다.")*/}
						{/*              }*/}
						{/*          }}*/}
						{/*    >*/}
						{/*        유튜브 보기*/}
						{/*    </Link>*/}
						{/*)}*/}

						{/*{reduxChannel?.instagram_link && (*/}
						{/*    <Link to={`/together/channel?id=${reduxChannel?.influencer_id}`}*/}
						{/*          onClick={(e) => {*/}
						{/*              if (reduxChannel?.user_id) {*/}
						{/*                  window.open(reduxChannel?.instagram_link);*/}
						{/*              } else {*/}
						{/*                  e.preventDefault();*/}
						{/*                  e.stopPropagation();*/}
						{/*                  alert("잘못된 접근입니다.")*/}
						{/*              }*/}
						{/*          }}>*/}
						{/*        인스타그램 보기*/}
						{/*    </Link>*/}
						{/*)}*/}
					</div>

					{/*{(reduxChannel?.user_id === 1 || (reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9)) && (*/}
					{/*)}*/}
					<Form
						size={`middle`}
						style={{
							gap: "0.5em",
							marginLeft: "auto",
							display: "flex",
							justifyContent: "flex-end",
							alignItems: "center",
						}}
						className={`channel-header-search`}
					>
						<>
							{cUser?.id ? (
								<Row
									style={{
										gap: "0.5em",
										flexWrap: "nowrap",
										marginLeft: "auto",
										alignItems: "center",
									}}
								>
									<img
										src={`/assets/images/user-icon.png`}
										alt={`유저 이미지`}
										style={{
											width: "auto",
											height: "1.4em",
											cursor: "pointer",
										}}
										onClick={() => {
											if (cUser?.id) {
												history.push(
													`/together/channel/mypage?id=${reduxChannel?.influencer_id}`
												);
											} else {
												loginAlert({ history, reduxChannel });
											}
										}}
									/>
									{/*<Tooltip*/}
									{/*    placement="bottom"*/}
									{/*    title={*/}
									{/*        <div className={`header-user-title`}>*/}
									{/*            {user ? (*/}
									{/*                <p>*/}
									{/*                    {user.nickname}*/}
									{/*                </p>*/}
									{/*            ) : (*/}
									{/*                <>*/}
									{/*                    <p>*/}
									{/*                        {cUser?.provider === "kakao" ? "카카오 로그인" : cUser?.provider === "naver" ? "네이버 로그인" : "일반 로그인"}*/}
									{/*                    </p>*/}
									{/*                    <p>*/}
									{/*                        {(cUser?.nickname) ? cUser?.nickname : (cUser?.phone?.slice(0, 3) + "****" + cUser?.phone?.slice(7, 11))}*/}
									{/*                        /!*{cUser?.phone?.slice(0, 3)}****{cUser?.phone?.slice(7, 11)}*!/*/}
									{/*                    </p>*/}
									{/*                </>*/}
									{/*            )}*/}
									{/*        </div>*/}
									{/*    }*/}
									{/*    arrow={true}*/}
									{/*    trigger={"click"}*/}
									{/*    // className={`header-user-div-mobile`}*/}
									{/*>*/}
									{/*    <img*/}
									{/*        src={`/assets/images/user-icon.png`}*/}
									{/*        alt={`유저 이미지`}*/}
									{/*        style={{*/}
									{/*            width: "auto",*/}
									{/*            height: "1.4em",*/}
									{/*            cursor: "pointer"*/}
									{/*        }}*/}
									{/*    />*/}
									{/*</Tooltip>*/}
									{/*{reduxChannel?.user_id !== 7 && (*/}
									{/*    <Popconfirm*/}
									{/*        placement="bottomRight"*/}
									{/*        overlayClassName={`logout-pop-confirm`}*/}
									{/*        title={"로그아웃하시겠습니까?"}*/}
									{/*        icon={null}*/}
									{/*        onConfirm={userLogout}*/}
									{/*        okText="네"*/}
									{/*        cancelText="아니요"*/}
									{/*    >*/}
									{/*        <p*/}
									{/*            className={`login-button`}*/}
									{/*            onClick={e => e.preventDefault()}*/}
									{/*            // onClick={cUserLogout}*/}
									{/*            // to={`/together/channel?id=${reduxChannel?.influencer_id}`}*/}
									{/*        >*/}
									{/*            로그아웃*/}
									{/*        </p>*/}
									{/*    </Popconfirm>*/}
									{/*)}*/}
								</Row>
							) : (
								<Link
									className={`login-button`}
									to={`/together/channel/login?id=${reduxChannel?.influencer_id}`}
									onClick={() => {
										let { pathname, search } = window.location;
										if (
											!pathname.includes("login") &&
											!pathname.includes("find") &&
											!pathname.includes("signup")
										) {
											sessionStorage.setItem("backPage", pathname + search);
										}
									}}
								>
									로그인/회원가입
								</Link>
							)}
							<p
								style={{
									position: "absolute",
									right: "-3em",
									top: "50%",
									transform: "translateY(-50%)",
									color: "white",
									userSelect: "all",
								}}
							>
								{reduxChannel?.signup_by_influencer}
							</p>
						</>
						{reduxChannel?.influencer_id === "mediman" && (
							<Input.Search
								type={`text`}
								placeholder={`성분명, 영양제명`}
								allowClear
								defaultValue={``}
								value={searchValue}
								onChange={(e) => {
									setSearchValue(e.target.value);
								}}
								onSearch={(value) => {
									if (value?.length > 0) {
										history.push(
											`/together/channel/search?query=${value}&id=${reduxChannel?.influencer_id}`
										);
										setSearchValue("");
									}
								}}
							/>
						)}
					</Form>
				</>
			)}
		</Row>
	);
};

export default ChannelHeader;
